
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/stripe/accounts",
      function () {
        return require("private-next-pages/tools/stripe/accounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/stripe/accounts"])
      });
    }
  